import LineItem from '../LineItem';

const ChargesLineItem = ({ penalty }) => (
  <LineItem title="Property Charges" totals={penalty}>
    This charge will not be refunded
  </LineItem>
);

ChargesLineItem.propTypes = {
  penalty: LineItem.propTypes.totals,
};

export default ChargesLineItem;
